import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon, TargetIcon, TrendingUpIcon, PaletteIcon, RocketIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'ELECTRICISTAS Y TÉCNICOS',
    image: 'https://cdn.magicpatterns.com/uploads/o8iDU6owR7oxYxBR8a4AQm/pasted-image.png',
    icon: <ZapIcon className="w-8 h-8 text-[#00f0ff]" data-id="element-305" />,
    badge: 'PERFIL TÉCNICO',
    checks: ['Dominá la instalación eléctrica de tiras LED Neon Flex', 'Aprendé a elegir fuentes y controladores adecuados', 'Soldaduras impecables y conexiones seguras paso a paso']
  }, {
    title: 'DISEÑADORES Y CREATIVOS',
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?q=80&w=2071&auto=format&fit=crop',
    icon: <PaletteIcon className="w-8 h-8 text-[#ec4899]" data-id="element-306" />,
    badge: 'PERFIL CREATIVO',
    checks: ['Plantillas y planos para crear carteles de alto impacto', 'Tipografías y trazos optimizados para Neon Flex', 'Técnicas para lograr el efecto de profundidad premium']
  }, {
    title: 'EMPRENDEDORES',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop',
    icon: <RocketIcon className="w-8 h-8 text-[#00f0ff]" data-id="element-307" />,
    badge: 'PERFIL NEGOCIO',
    checks: ['Calculá costos y precios con alto margen de ganancia', 'Estrategias para conseguir tus primeros clientes', 'Cómo escalar tu taller a un negocio rentable']
  }];
  return <section className="py-24 bg-transparent relative overflow-hidden pt-[9px] pb-[9px] space-y-[20px]" data-id="element-308">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-309">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black text-center text-white mb-20 tracking-tight uppercase" data-id="element-310">
          LO QUE TE LLEVÁS CON <br data-id="element-311" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#ec4899]" data-id="element-312">
            NEON FLEX ACADEMY
          </span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-313">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#1a0b2e]/40 rounded-[2.5rem] overflow-hidden border border-white/5 flex flex-col h-full group hover:border-[#00f0ff]/30 transition-all duration-500" data-id="element-314">
              <div className="relative mb-8 rounded-2xl overflow-hidden border border-white/10 aspect-[3/2]" data-id="element-315">
                <img src={item.image} alt={item.title} width={600} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-316" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e] via-transparent to-transparent opacity-40" data-id="element-317" />
              </div>

              <div className="p-10 flex flex-col flex-grow" data-id="element-318">
                <div className="flex items-center gap-3 mb-6" data-id="element-319">
                  {item.icon}
                  <h3 className="text-2xl font-black text-white tracking-wide uppercase" data-id="element-320">
                    {item.title}
                  </h3>
                </div>

                <ul className="space-y-5 mb-10 flex-grow" data-id="element-321">
                  {item.checks.map((check, j) => <li key={j} className="flex items-start gap-4" data-id="element-322">
                      <div className="mt-1 bg-[#00f0ff]/20 rounded-full p-1 shadow-[0_0_10px_rgba(0,240,255,0.2)]" data-id="element-323">
                        <CheckIcon className="w-4 h-4 text-[#00f0ff]" data-id="element-324" />
                      </div>
                      <span className="text-gray-300 text-lg font-bold leading-tight" data-id="element-325">
                        {check}
                      </span>
                    </li>)}
                </ul>

                <div className="mt-auto" data-id="element-326">
                  <div className="inline-block px-8 py-2.5 rounded-full bg-[#00f0ff]/5 border border-[#00f0ff]/20 text-[#00f0ff] text-xs font-black tracking-[0.2em] uppercase" data-id="element-327">
                    {item.badge}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}